import { render, staticRenderFns } from "./sales-input.vue?vue&type=template&id=1440b8a2&scoped=true&"
import script from "./sales-input.vue?vue&type=script&lang=js&"
export * from "./sales-input.vue?vue&type=script&lang=js&"
import style0 from "./sales-input.vue?vue&type=style&index=0&id=1440b8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1440b8a2",
  null
  
)

export default component.exports